import type { API } from 'chessboard/api/config/types';
import type { Game } from 'model/game/types';

/**
 * Create the getTurn method.
 */
export function createGetTurn(context: API.Context) {
  /**
   * Get next color to move.
   */
  return function getTurn(): Game.ColorsAsNumbers {
    const { game } = context;

    return game.turn();
  };
}
